export const COS_TONES = [
  "balanced",
  "warm",
  "direct",
  "concise",
  "sassy",
] as const;

export type CosTone = (typeof COS_TONES)[number];

export function isCosTone(value: unknown): value is CosTone {
  return COS_TONES.includes(value as CosTone);
}

export const DEFAULT_COS_TONE: CosTone = "balanced";

export const COS_TONE_LABELS: Record<CosTone, string> = {
  balanced: "Balanced",
  warm: "Warm",
  direct: "Direct",
  concise: "Concise",
  sassy: "Sassy",
};

export const COS_TONE_DESCRIPTIONS: Record<CosTone, string> = {
  balanced: "Balanced, thoughtful, and clear.",
  warm: "Encouraging, friendly, and reassuring.",
  direct: "Straightforward, decisive, and efficient.",
  concise: "Minimal, high-signal, and brief.",
  sassy: "Playful, witty, and a little sharp.",
};

export const cosToneSamples: Record<CosTone, string> = {
  balanced:
    "The Acme contract is stuck with legal. I've flagged it to Mike and I'll check back Thursday.",
  warm: "Small snag on the Acme contract, legal still has it. I've nudged Mike and I'll keep an eye on it for you.",
  direct:
    "Acme contract: blocked on legal. Flagged to Mike. Checking Thursday.",
  concise: "Acme contract stuck in legal. Mike flagged. Thursday.",
  sassy:
    "The Acme contract is still sitting in legal's inbox, gathering dust. Mike's been nudged. I'll chase Thursday.",
};
